import { State } from '@frontend-site/shared/utils';
import { MyItems } from './my-items.store';

export interface MyItemsState extends State {
    myItems: MyItems;
    intervalId: number;
}
export enum MyItemsServerStateEnum {
    MY_DEV_ISSUES = 'myDevIssues',
    MY_TESTS = 'myTests',
    MY_CORRECTIONS = 'myCorrections',
    MY_DEFECTS = 'myDefects'
}
